import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

interface PillarHeroAvatarProps {
  icon: LucideIcon;
  className?: string;
}

export function PillarHeroAvatar({ icon: Icon, className }: PillarHeroAvatarProps) {
  return (
    <div
      className={cn(
        'bg-fin-purple/15 text-fin-purple flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl',
        className
      )}
    >
      <Icon className='h-7 w-7' aria-hidden />
    </div>
  );
}
